
import {
    ResultsTableBasicItemTemplate, ResultsTableInviteesItemTemplate,
    ResultsTableLanguagesItemTemplate, ResultsTableParticipantsItemTemplate,
} from '../types'
import {
    actionsWrapper, avatarNameWrapper, closeButtonStyles,
} from '../styles/templates.styles'
import {HeroXMarkIcon} from 'components/Icon'
import LetterAvatar from 'components/Avatar/LetterAvatar'
import React from 'react'
import User from 'components/User'
import {resultsTableTd} from '../styles/ResultsTableView.styles'
import {styled} from 'stitches/config'
import {translate} from 'utils/cannedmessages'
import {useTranslation} from 'react-i18next'

const StyledResultsTableTd = styled('td', resultsTableTd)
const StyledCloseButton = styled('button', closeButtonStyles)
const StyledDefaultButton = styled('button', StyledCloseButton, {
    fontWeight: '900',
    marginRight: '2em',
})
const StyledAvatarNameWrapper = styled('div', avatarNameWrapper)
const StyledActionsWrapper = styled('div', actionsWrapper, {justifyContent: 'flex-end'})

export const ResultsTableBasicTemplate = ({
    name, content, handleRemove, canRemove = true,
}: ResultsTableBasicItemTemplate) => (
    <>
        <StyledResultsTableTd>{name}</StyledResultsTableTd>
        <StyledResultsTableTd>{content}</StyledResultsTableTd>
        <StyledResultsTableTd>
            {canRemove ? <StyledCloseButton onClick={handleRemove} type='button'><HeroXMarkIcon size={18} /></StyledCloseButton> : null}
        </StyledResultsTableTd>
    </>
)

export const ResultsTableInviteesTemplate = ({
    name, handleRemove, id, tabIndex,
}: ResultsTableInviteesItemTemplate) => (
    <>
        <StyledResultsTableTd css={{
            boxSizing: 'border-box',
            maxWidth: '50px',
            width: '50px',
        }}
        ><StyledAvatarNameWrapper>{id ? <User avatarOnly={true} userId={id} /> : <LetterAvatar name={name} />}</StyledAvatarNameWrapper>
        </StyledResultsTableTd>
        <StyledResultsTableTd>{name}</StyledResultsTableTd>
        <StyledResultsTableTd>
            <StyledCloseButton onClick={handleRemove} tabIndex={tabIndex}><HeroXMarkIcon size={18} /></StyledCloseButton>
        </StyledResultsTableTd>
    </>
)


export const ResultsTableParticipantsTemplate = ({
    name, email, info, action, handleRemove,
}: ResultsTableParticipantsItemTemplate) => (
    <>
        <StyledResultsTableTd><StyledAvatarNameWrapper><LetterAvatar name={name} />{name}</StyledAvatarNameWrapper></StyledResultsTableTd>
        <StyledResultsTableTd>{email}</StyledResultsTableTd>
        <StyledResultsTableTd>{info}</StyledResultsTableTd>
        <StyledResultsTableTd>
            <StyledActionsWrapper>
                {action}
                <StyledCloseButton onClick={handleRemove}><HeroXMarkIcon size={18} /></StyledCloseButton>
            </StyledActionsWrapper>
        </StyledResultsTableTd>
    </>
)
export const LanguageResultTableTemplate: React.FC<ResultsTableLanguagesItemTemplate> = ({
    code,
    isDefault,
    name,
    canRemove = true,
    handleRemove,
    makeDefault,
}) => {
    const {t} = useTranslation()
    return (
        <>
            <StyledResultsTableTd>{code}</StyledResultsTableTd>
            <StyledResultsTableTd>{translate(name, t)} {isDefault ? <span>({t('default')})</span> : null}</StyledResultsTableTd>
            <StyledResultsTableTd>
                <StyledActionsWrapper>
                    {isDefault === false
                        ? <StyledDefaultButton onClick={makeDefault} type='button'>{t('Make default')}</StyledDefaultButton>
                        : null}
                    {canRemove ? <StyledCloseButton onClick={handleRemove} type='button'><HeroXMarkIcon size={18} /></StyledCloseButton> : null}
                </StyledActionsWrapper>
            </StyledResultsTableTd>
        </>
    )
}

